// 弹窗组件
import { Modal, ModalProps, Spin } from "@arco-design/web-react";
import "./index.less";

interface AiModalProps extends ModalProps {
  children?: React.ReactNode;
  cancelText?: string;
  submitText?: string;
  onSubmit?: () => void;
  onCancel?: () => void;
  showFooter?: boolean;
  showCancel?: boolean;
  showSubmit?: boolean;
  hasPadding?: boolean;
  showLine?: { width?: number; color?: string } | boolean;
}

const AiModal: React.FC<AiModalProps> = (props) => {
  const {
    cancelText = "取消",
    submitText = "确认",
    children,
    onSubmit,
    onCancel,
    showFooter = true,
    showCancel = true,
    showSubmit = true,
    showLine = false,
    hasPadding = true,
    ...reset
  } = props;
  const lineConfig: any = typeof showLine === "object" ? showLine : !showLine ? false : {};
  return (
    <Modal
      {...reset}
      onCancel={onCancel}
      title={
        <div className={showLine ? "ai_modal_title" : ""}>
          {props?.title || ""}
          <div
            className="ai_modal_title_line"
            style={showLine ? { width: lineConfig?.width || 100, backgroundColor: lineConfig?.color || "#333" } : {}}
          ></div>
        </div>
      }
      footer={
        showFooter ? (
          <div className="ai-modal-footer">
            {showCancel && (
              <div className="footer_btn cancel" onClick={onCancel}>
                {cancelText}
              </div>
            )}
            {showSubmit && (
              <Spin loading={props.confirmLoading}>
                <div className="footer_btn submit" onClick={onSubmit}>
                  {submitText}
                </div>
              </Spin>
            )}
          </div>
        ) : null
      }
    >
      <div style={hasPadding ? { padding: "16px 0", boxSizing: "border-box" } : {}}>{children}</div>
    </Modal>
  );
};

export default AiModal;
